import { render, staticRenderFns } from "./LegalRepresentative.vue?vue&type=template&id=0f4c9940&scoped=true"
import script from "./LegalRepresentative.vue?vue&type=script&lang=js"
export * from "./LegalRepresentative.vue?vue&type=script&lang=js"
import style0 from "./LegalRepresentative.vue?vue&type=style&index=0&id=0f4c9940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c9940",
  null
  
)

export default component.exports